import script from "./MenuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuComponent.vue?vue&type=style&index=0&id=71ffc837&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ffc837"]])

export default __exports__